import {queryBuilderApiUrl} from "../../actions/api";
import {CodeValue} from "./types/CodeValue";
import {Field} from "./types/Field";
import {Query, QueryResult} from "./types/Query";
import {UserQuery} from "./types/UserQuery";
import {GenericTree} from "./types/GenericTree";
import {CONFIG} from "../../util/config";

export const apiFetchFields = async (): Promise<Field[]> => {
    const url = queryBuilderApiUrl() + '/fields'
    const result = await fetch(url, {
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return result.json()
}

export const apiFetchMapping = async (fieldCode: string, filter: string = '', limit?: number): Promise<CodeValue[]> => {
    return apiFetchMappingWithQualifier(fieldCode, filter, undefined, undefined, limit)
}

export const apiFetchMappingWithQualifier = async (fieldCode: string, filter: string = '', qualifier?: string, searchType?: string, limit?: number): Promise<CodeValue[]> => {
    let params = `filter=${filter}`
    if (qualifier) {
        params += `&qualifier=${qualifier}`
    }
    if (searchType) {
        params += `&searchType=${searchType}`
    }
    if (limit) {
        params += `&limit=${limit}`
    }
    const url = encodeURI(queryBuilderApiUrl() + `/mapping/${fieldCode}?${params}`)
    const result = await fetch(url, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return result.json()
}

export const apiFetchDialogChoices = async (endpoint: string, fieldCode: string): Promise<GenericTree[]> => {
    const url = queryBuilderApiUrl() + `/${endpoint}/${fieldCode}`
    const result = await fetch(url, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return result.json()
}

export const apiFetchUserQuery = async (queryId: string): Promise<UserQuery> => {
    const result = await fetch(queryBuilderApiUrl() + `/query/${queryId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return result
        .json()
        .then(i => {
            // @ts-ignore
            i.query = JSON.parse(i.query)
            return i
        })
}

export const apiRunQuery = async (queryId: string, query: Query): Promise<{ data: string }> => {
    const result = await fetch(queryBuilderApiUrl() + `/query/${queryId}`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(query),
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return result.json()
}

export const apiFetchQueryResult = async (queryId: string): Promise<QueryResult | undefined> => {
    const response = await fetch(queryBuilderApiUrl() + `/query/${queryId}/result`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    if (response.ok) {
        return response
            .json()
            .catch(e => {
                console.log(e)
                return undefined
            })
    } else {
        console.log(response)
        return {
            message: `${response.status}: ${response.statusText}`,
            valueAvailable: false
        } as QueryResult
    }
}

export const apiFetchQueries = async (filter: string, isCohortAnalyser: boolean): Promise<UserQuery[] | undefined> => {
    const result = await fetch(queryBuilderApiUrl() + `/search?filter=${filter}&isCohortAnalyser=${isCohortAnalyser}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return result
        .json()
        .catch(e => {
            console.log(e)
            return undefined
        })
}

export interface UpdateQueryType {
    favourite?: boolean
    shared?: boolean
    sharedUser?: string
    saved?: boolean
    delete?: boolean
    cancel?: boolean
    category?: string
    label?: string
}

export const apiUpdateQuery = async (queryId: string, data: UpdateQueryType): Promise<any | undefined> => {
    const result = await fetch(queryBuilderApiUrl() + `/query/${queryId}`, {
        method: 'PATCH',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return result.text()
}

export interface User {
    name: string
    login: string
}

export const apiFetchUsersInCompany = async (): Promise<User[]> => {
    const result = await fetch(queryBuilderApiUrl() + '/users', {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return result
        .json()
        .catch(e => {
            console.log(e)
            return undefined
        })
}